import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.VehicleClass.Delete.IRequest;
type Response = Api.Core.VehicleClass.Delete.IResponse;
type Headers = Api.Core.VehicleClass.Delete.IHeaders;
const url = '/api/ProductManagement/VehicleClass/:id';
export default async function vehicleClassDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
